<template>
  <Dropdown>
    <a class="lang-switch" @click.prevent>
      {{ LangType[settingStore.locale] }}
    </a>
    <template #overlay>
      <Menu @click="handleMenuClick">
        <MenuItem
          key="zh"
          v-if="['cabinet-front-cn', 'cabinet-front-my', 'cabinet-front-id'].includes(useSubpackageName().area)"
        >
          {{ LangType.zh }}
        </MenuItem>
        <MenuItem key="hk" v-if="['cabinet-front-cn'].includes(useSubpackageName().area)"> {{ LangType.hk }} </MenuItem>
        <MenuItem key="en" v-if="['cabinet-front-my', 'cabinet-front-id'].includes(useSubpackageName().area)">
          {{ LangType.en }}
        </MenuItem>
        <MenuItem key="my" v-if="['cabinet-front-my'].includes(useSubpackageName().area)"> {{ LangType.my }} </MenuItem>
        <MenuItem key="id" v-if="['cabinet-front-id'].includes(useSubpackageName().area)"> {{ LangType.id }} </MenuItem>
      </Menu>
    </template>
  </Dropdown>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { Dropdown, Menu, MenuItem } from 'ant-design-vue'
  import type { MenuProps } from 'ant-design-vue'
  import { useSettingStore } from '@jms/store'
  import LangType from '@jms/utils/enums/LangType'
  import { dictService } from '@jms/api/api'
  import { useApi } from '@xinghai/site-common'
  import { isSuccess } from '@jms/utils'
  import { useSubpackageName } from '@jms/hooks'
  const sysSetting = useSettingStore()
  console.log(useSubpackageName(), 'useSubpackageName**************')
  const locale = computed(() => sysSetting.locale)
  interface Props {
    /**是否重载页面 */
    reload?: boolean
  }
  const props = defineProps<Props>()
  const settingStore = useSettingStore()
  const { fetchData, result } = useApi(dictService.getI18n)
  fetchData().then((res) => {
    const obj = {
      zh: {},
      hk: {},
      en: {},
      my: {},
      id: {}
    }
    obj[locale.value] = result.value
    settingStore.langJson = obj[locale.value]
  })
  type Lang = keyof typeof LangType

  const handleMenuClick: MenuProps['onClick'] = async (e: any) => {
    console.log('e :>> ', e)
    settingStore.locale = e.key as Lang
    const obj: Record<Lang, Record<string, any>> = {
      zh: {},
      hk: {},
      en: {},
      my: {},
      id: {}
    }
    const res = await fetchData()
    if (!isSuccess(res)) return
    obj[e.key as Lang] = result.value
    settingStore.langJson = obj[e.key as Lang]
    if (props.reload) {
      location.reload()
    }
  }
</script>
<style lang="less" scoped>
  .lang-switch {
    height: 32px;
    line-height: 32px;
    width: 56px;
    text-align: center;
    border-radius: 16px;
    background-color: @white;
    color: @primary-color;
    display: inline-block;
  }
</style>
